<div class="infocard-wrapper">
    <button class="close" (click)="close()"></button>

    <stage-header [projectStage]="projectData()?.projectStage" [projectInfo]="projectData()?.projectInfo"
        [publications]="publications()" [mapMode]="true"></stage-header>

    <project-stage-selector [projectStages]="projectData()?.projectInfo?.stageEstateTypesModel?.projectStageEstateTypes"
        [setSelectedStage]="selectedProjectStage()" (selectedStage)="onSelect($event)"></project-stage-selector>
    
    <div class="map-buttons">
        <div class="show-position" (click)="showInMap()">
            <div class="show-position-icon"></div>
            <span>Vis posisjon</span>
        </div>
        <div class="center-map" (click)="centerMap()">
            <div class="center-map-icon"></div>
            <span>Sentrer</span>
        </div>
    </div>

    <div class="images">
        @if (!stageMode() && projectData()?.projectInfo?.numUnits > 0) {
        <div class="sold-overlay">
            <div class="circular-progress">
                <ev-circular-progress [size]="'120px'" [strokeWidth]="10"
                    [maxValue]="projectData()?.projectInfo?.numUnits" [segments]="segments()">
                    <div class="circular-progress-inner-content">
                        <div class="toptext">{{ percentSold() }}%</div>
                        <div class="undertext">solgt</div>
                    </div>
                </ev-circular-progress>
            </div>
        </div>
        }
        @if(hasImages()) {
        <image-carousel [imagePackages]="imagePackages()" [imageBorderRadius]="false"></image-carousel>
        } @else {
        <div class="no-image-placeholder"></div>
        }
    </div>

    @if(this.stageMode()) {
    <project-stages-compact [projectData]="projectData()"
        [selectedProjectStage]="selectedProjectStage()"></project-stages-compact>
    }

    <div class="key-info">
        <key-info-project [projectData]="projectData()" [stageMode]="stageMode()"></key-info-project>
    </div>

    <infopage-links-nd [miniInfocard]="true" class="infopage-links" [stageMode]="stageMode()"
        [dwellingProjectInfo]="projectData()?.projectInfo" [dwellingStageInfo]="projectData()?.projectStage"
        [publications]="publications()">
    </infopage-links-nd>

    @if(!stageMode()) {
    <project-stages-compact [projectData]="projectData()"
        [selectedProjectStage]="selectedProjectStage()"></project-stages-compact>
    }

    @if(this.stageMode()) {
        <div class="border-top">
            <statistics-compact [prospectUnits]="projectData()?.prospectUnits"></statistics-compact>
            <units-groups [unitsFilterGroups]="unitsFilterGroups()"></units-groups>
        </div>
    }
</div>